export default __webpack_public_path__ + "static/media/man.6a37abd1.ogg";